module.exports = __webpack_public_path__ + "img/ico-hesap-yonetim.a67e1367.svg";